import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GamesListWithTicketsComponent } from './games-list-with-tickets.component';
import { DataSourceDirective, DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { TicketTransferGamePanelModule } from '../ticket-transfer-game-panel/ticket-transfer-game-panel.module';

@NgModule({
  declarations: [GamesListWithTicketsComponent],
  imports: [
    CommonModule,
    TicketTransferGamePanelModule,
    DirectivesModule,
    FGBSharedModule,
    DataSourceDirective
  ],
  exports: [GamesListWithTicketsComponent],
})
export class GamesListWithTicketsModule {}
